<template>
  <v-data-table :headers="headers" :items="computedUnits" :footer-props="{
    'items-per-page-options': [4, 8, 12, 16],
  }" :items-per-page.sync="itemsPerPage" :page.sync="page" :loading="fetchingAll"
    loading-text="Loading... Please wait" class="elevation-1">
    <template v-slot:item="row">
      <tr>
        <td>{{ row.item.unit }}</td>
        <td>{{ row.item.description }}</td>
        <td>{{ row.item.date }}</td>
        <td>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn v-if="authPermissions.has('stock_units:edit')" class="mx-2" fab dark small v-bind="attrs" v-on="on"
                color="yellow" @click="editUnit(row.item)">
                <v-icon dark>mdi-pencil</v-icon>
              </v-btn>
            </template>
            <span>Edit Unit</span>
          </v-tooltip>
        </td>
      </tr>
    </template>
  </v-data-table>
</template>

<script>
import { mapState, mapActions } from 'vuex'
export default {
  name: 'vUnitIndex',
  data() {
    return {
      headers: [
        { text: 'Unit', value: 'unit' },
        { text: 'Description', value: 'description' },
        { text: 'Date Created', value: 'date' },
        { text: 'Config' },
      ],
      itemsPerPage: 5,
      page: 1,
    }
  },
  computed: {
    ...mapState({
      fetchingAll: state => state.unit.fetchingAll,
      units: state => state.unit.allList,
      unitUpdated: state => state.unit.channelUpdate,
      authPermissions: state => state.auth.userPermissions,
      // unitCount: state => state.unit.dataCount,
    }),
    computedUnits() {
      return this.units.map(e => {
        const date = new Date(e.created_at)
        const year = date.getFullYear()
        const month = (`${date.getMonth() + 1}`).padStart(2, '0')
        const day = (`${date.getDate()}`).padStart(2, '0')
        return {
          ...e,
          date: `${month}/${day}/${year}`,
        }
      })
    },
  },
  watch: {
    unitUpdated() {
      this.fetchingAll()
    },
  },
  methods: {
    ...mapActions({
      fetchAll: 'unit/fetchAll',
    }),
    editUnit(data) {
      this.$emit('editUnit', data)
    },
  },
}
</script>
